import { token } from '@cp/shared/di';
import { IModalManager, ModalStat } from './manager.interface';

export const MODAL_MANAGER = token<IModalManager>('MODAL_MANAGER');
export const MODAL_STATS_PROVIDER = token<{ stats: ModalStat }>('STATS_PROVIDER');
